module.exports = __webpack_public_path__ + "static/media/homepage_atf_1_mo.2318dba1.png";